import { FC } from 'react';

import { clientConfig } from '@/config/client';

import { usePlayerAnalytics } from '../../../hooks/tracker/use-player-analytics';
import { useInitFilmTracker } from '../../../../film-player/hooks/use-init-film-tracker';
import { useFilmPrerollAnalytics } from '../../../../film-player/hooks/use-film-preroll-analytics';
import { useFilmCurrentStream } from '../../../../film-player/hooks/use-film-current-stream';
import { useFilmPrerollDurationWatcher } from '../../../../film-player/hooks/use-film-preroll-duration-watcher';

const { yandexMetrika } = clientConfig;

interface Props {
    contentId: string;
    psid: string;
}

export const FilmPlayerTracker: FC<Props> = ({ contentId, psid }) => {
    const currentStream = useFilmCurrentStream(contentId);
    useFilmPrerollDurationWatcher(contentId);

    useInitFilmTracker(contentId, yandexMetrika);
    usePlayerAnalytics({
        contentId,
        psid,
        manifestUrl: currentStream?.uri,
        viewStartedGtmEvent: 'MOVIES_VIEW_STARTED',
    });
    useFilmPrerollAnalytics({ contentId });

    return null;
};
